/**
 * Created by Shiv Roy on 23/11/17.
 */
import { appConfigActionTypes } from './../constants';

const initialState = {
  loading: false,
  appConfigList: null,
  fieldError: [],
  appConfigAdded: false,
  fieldErrorLoading: false,
  statusData: {},
  latitude: null,
  longitude: null,
  clockInLatitude: null,
  clockInLongitude: null,
  clockOutLatitude: null,
  clockOutLongitude: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case appConfigActionTypes.post_app_config.REQUEST:
  case appConfigActionTypes.update_active_status.REQUEST:
    return {
      ...state,
      loading: true,
      fieldError: [],
    };

  case appConfigActionTypes.field_exist_error.REQUEST:
    return {
      ...state,
      fieldErrorLoading: true,
      //fieldError: [],
    };

  case appConfigActionTypes.clear_field_exist_error.REQUEST:
    return {
      ...state,
      fieldErrorLoading: true,
      fieldError: [],
    };
    case appConfigActionTypes.get_app_config.REQUEST:
    return {
      ...state,
      loading: true,
      appConfigList: null,
    };
  case appConfigActionTypes.get_app_config.SUCCESS:
    return {
      ...state,
      loading: false,
      appConfigList: payload,
    };


  case appConfigActionTypes.post_app_config.SUCCESS:
    return {
      ...state,
      loading: false,
      appConfigAdded: true,
    };

  case appConfigActionTypes.clear_field_exist_error.SUCCESS:
    return {
      ...state,
      fieldErrorLoading: false,
      fieldError: [],
    };

  case appConfigActionTypes.field_exist_error.SUCCESS:
  /*  let ErrorArr = [];
    let copyArr = Object.assign({}, state);
    if (copyArr.fieldError && copyArr.fieldError.length) { // Remove/Check if error exists.
      ErrorArr = copyArr.fieldError.filter((error) => {
        if ((error.statusCode !== payload.statusCode) && (error.data !== payload.data)) {
          return error;
        }
      });
    } else {
      if (payload.statusCode === 409) {
        ErrorArr.push(payload); // Insert/Add only error
      }
    }*/
    let ErrorArr = [];
    let existingError = false;
    let copyArr = Object.assign({}, state);
    if (copyArr.fieldError && copyArr.fieldError.length) { // Remove/Check if error exists.
      copyArr.fieldError.filter((data) => {   // copy old errors
        ErrorArr.push(data);
        return ErrorArr;
      });
      copyArr.fieldError.some((error) => {
        if ((error.data === payload.data)) {    //  Insert Error
          existingError = true;
        }
        return existingError;
      });
      if (existingError && payload.statusCode !== 409) {  // Remove
        ErrorArr = ErrorArr.filter((data) => {
          return data.data !== payload.data;
        });
      } else {    //  Insert
        if (!existingError && payload.statusCode === 409) {
          ErrorArr.push(payload);
        }
      }
    } else {    // Insert/Add only one error
      if (payload.statusCode === 409) {
        ErrorArr.push(payload);
      }
    }
    return {
      ...state,
      fieldErrorLoading: false,
      fieldError: ErrorArr,
    };
  case appConfigActionTypes.update_active_status.SUCCESS:
    return {
      ...state,
      loading: false,
      statusData: payload,
    };
  case appConfigActionTypes.get_GEO_Location.REQUEST:
    return {
      ...state,
      loading: true,
      latitude: null,
      longitude: null,
    };
  case appConfigActionTypes.get_GEO_Location.SUCCESS:
    return {
      ...state,
      loading: false,
      latitude: (payload != null && payload.coords != null && payload.coords.latitude ? payload.coords.latitude : 0.0 ),
      longitude: (payload != null && payload.coords != null && payload.coords.longitude ? payload.coords.longitude : 0.0),
      // latitude: 0.0,
      // longitude: 0.0,
    };
    case appConfigActionTypes.get_GEO_Location_ClockIn.REQUEST:
      return {
        ...state,
        loading: true,
        clockInLatitude: null,
        clockInLongitude: null,
      };
    case appConfigActionTypes.get_GEO_Location_ClockIn.SUCCESS:
      return {
        ...state,
        loading: false,
        clockInLatitude: (payload != null && payload.coords != null && payload.coords.latitude ? payload.coords.latitude : 0.0 ),
        clockInLongitude: (payload != null && payload.coords != null && payload.coords.longitude ? payload.coords.longitude : 0.0),       
      };
    case appConfigActionTypes.get_GEO_Location_ClockOut.REQUEST:
      return {
        ...state,
        loading: true,
        clockOutLatitude: null,
        clockOutLongitude: null,
      };
    case appConfigActionTypes.get_GEO_Location_ClockOut.SUCCESS:
      return {
        ...state,
        loading: false,
        clockOutLatitude: (payload != null && payload.coords != null && payload.coords.latitude ? payload.coords.latitude : 0.0 ),
        clockOutLongitude: (payload != null && payload.coords != null && payload.coords.longitude ? payload.coords.longitude : 0.0),       
      };

  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/AppConfig/reducers/index.js